import React, { useEffect, useState } from 'react'
import {
  CAvatar,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilNotes } from '@coreui/icons';
import PencilIcon from '../icons/PencilIcon';
import TNC from '../icons/TermNConditions';
import LogOutIcon from '../icons/LogoutIcon';
import FNQIcon from '../icons/faqIcon';
import CustomerCareIcon from '../icons/CustomerCareIcon';
import Home from '../icons/Home.svg';
import avatar from '../../assets/images/avatars/blank_user_image.png'
import { Link } from 'react-router-dom';
import { Profile } from '../../API/player';


const ScorerAppHeaderDropdown = () => {
  const [profile, setProfile] = useState(null);
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;

  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile();
      if (res.status) {
        console.log(res.data.profile_image);
        setProfile(res.data);
      }
    }
    callAPI();
  }, [])

  return (
    <CDropdown variant="nav-item" className='header-nav-dropdown user_dashboard_header'>
      <CDropdownToggle placement="bottom-end" className="py-0 pe-0" caret={false}>
        <div className='profile_header_userdash' style={{
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          // backgroundImage: profile && profile.profile_image ?
          //   `url(${IMAGE_URL}user/${profile.profile_image})` :
          //   `url(${IMAGE_URL}/blank_user.png)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
          <img
            src={profile && profile.profile_image ? `${IMAGE_URL}user/${profile.profile_image}` : `${IMAGE_URL}/blank_user.png`}
            alt="Profile" style={{ height: "100%", width: "100%", borderRadius: "50%", objectFit: "cover" }}
          />
        </div>
        {/* <CAvatar src={avatar} size="md" className='user_prof_img_score' /> */}
      </CDropdownToggle>
      <CDropdownMenu className="py-0 " placement="bottom-end">
        <Link to='/' className='text-decoration-none'>
          <CDropdownItem className='text-white py-2'>
            <img src={Home} style={{ height: '18px', width: '18px' }}></img>
            <span className='ps-2 '> Home </span>
          </CDropdownItem>
        </Link>
        <Link to='/scorer/profile' className='text-decoration-none'>
          <CDropdownItem className='text-white py-2'>
            <PencilIcon />
            <span className='ps-2 '> My Profile </span>
          </CDropdownItem>
        </Link>

        {/* <CDropdownItem href="/terms&condition" className='text-white py-2'>
          <TNC />
          <span className='ps-2'> Terms & Conditions</span>
        </CDropdownItem>

        <CDropdownItem href="/privacy&policy" className='text-white py-2'>
          <CIcon icon={cilNotes} style={{ height: "20px", width: "20px" }} />
          <span className='ps-2'> Privacy Policy</span>
        </CDropdownItem> */}

        {/* <CDropdownItem href="#" className='text-white py-2'>
          <CustomerCareIcon />
          <span className='ps-2'> Help & Support</span>
        </CDropdownItem> */}
        {/* 
        <CDropdownItem href="/#faqs" className='text-white py-2'>
          <FNQIcon />
          <span className='ps-2'> FAQ</span>
        </CDropdownItem> */}

        <CDropdownItem href="/logout" className='text-white py-2'>
          <LogOutIcon />
          <span className='ps-2'> Logout</span>
        </CDropdownItem>

      </CDropdownMenu>
    </CDropdown>
  )
}

export default ScorerAppHeaderDropdown
